var clamp = {exports: {}};

export { clamp as __module };
